import Axios from 'axios';

export const APICallInstance = Axios.create({
    baseURL: import.meta.env.VITE_APP_API_BASE_URL_DEV,
    withCredentials: true
});

APICallInstance.interceptors.request.use(
    (config) => {
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

APICallInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const APICallInstanceNoAuth = Axios.create({
    baseURL: import.meta.env.VITE_APP_API_BASE_URL_DEV
});

APICallInstanceNoAuth.interceptors.request.use(
    (config) => {
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

APICallInstanceNoAuth.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);
